(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ekipa-product-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-ekipa-size-guide-open]');

    if (openButton) {
      const wrapper = openButton.closest('.ekipa-product-details');
      const modal = wrapper?.querySelector('[data-ekipa-size-guide-modal]');

      if (modal) {
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }
      }
    }

    const closeButton = event.target.closest('[data-ekipa-size-guide-close]');

    if (closeButton) {
      const modal = closeButton.closest('[data-ekipa-size-guide-modal]');

      if (modal) {
        modal.close();
      }
    }

    if (event.target.matches('[data-ekipa-size-guide-modal]')) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
